import cardIcon from '@material-ui/icons/CardMembership';

import  UserList   from './userList';
import  UserShow  from './userShow';
import UserEdit  from './userEdit';
import UserCreate  from './userCreate';

export default {
	list: UserList,
	show: UserShow,
	edit:UserEdit,
	create:UserCreate,
	icon: cardIcon,
 }
